import Token from 'vindi-ds-tokens';

const buttonRoot = {
  marginTop: '16px',
  minWidth: '208px',
};

export default {
  locked: {
    boxShadow: 'none',
    backgroundColor: Token.color.functional.light['200'].value,
  },
  complete: {
    backgroundColor: '#DBFFE1',
    boxShadow: 'none',
  },
  incomplete: {
    boxShadow: Token.shadow.level3.value,
    backgroundColor: Token.color.functional.light['200'].value,
  },
  buttonStyle: {
    ...buttonRoot,
  },
  buttonLocked: {
    pointerEvents: 'none',
    ...buttonRoot,
  },
};
